module.exports = __webpack_public_path__ + "static/media/5.31188675.png";